/* global ChoiceOption */
import _ from 'lodash';
import {
  GlobalFilter, BuilderValues, Client, SqlOptions, SystemTypeEnum,
} from '../column-filter.types';
import {
  getPriorities, dueDate, date, linkedTasks, sqlMap, filterKeyMap,
} from '.';

export async function getValues({
  cat,
  api,
  sqlOptions,
  recordFilters,
  type,
}: BuilderValues) {
  if (!sqlOptions) {
    throw Error('Records can not be loaded without a form and schema');
  }
  const { restForm } = sqlOptions;
  const itaType = cat === 'type';

  const categoryMapped = itaType ? cat : filterKeyMap[type][cat];
  const sql = sqlMap(categoryMapped, restForm.id, type, recordFilters.globalFilter);

  const res = await api.query.queryRecords({ q: sql });
  let records: ChoiceOption[] = res;

  if (itaType) {
    records = res.map((record: ChoiceOption) => ({
      label: record.label.toString(),
      value: record.value.toString(),
    }));
  }

  return records;
}

export async function returnValuesFor(
  api: Client,
  cat: string,
  sqlOptions: SqlOptions,
  recordFilters: GlobalFilter,
  type: SystemTypeEnum,
) {
  let values: ChoiceOption[] = [];

  switch (cat) {
    case 'due_date':
      return dueDate;
    case 'date_filter':
      return date;
    case 'tasks':
      return linkedTasks;
    case 'priority':
      return getPriorities(sqlOptions.restForm);
    case 'status':
      return sqlOptions.restForm?.status_field.choices;
    case 'type':
    case 'assigned_to':
    case 'reported_by':
    case 'project':
      values = await getValues({
        cat, api, sqlOptions, recordFilters, type,
      });
      return _.uniqBy(values, 'value');
    default:
      return [];
  }
}
